module.exports = __webpack_public_path__ + "static/mobile-9da4fe26403ea20a41c9510684c775d7.svg";